(() => {
  'use strict';
  const headers = new Map();
  const initialize = (scope = document) => {
    const candidates = [...scope.querySelectorAll('[data-ps-header]')];
    if (scope.matches?.('[data-ps-header]')) candidates.unshift(scope);
    candidates.forEach(header => {
      if (headers.has(header)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const menus = [...header.querySelectorAll('[data-ps-mega]')];
      const desktop = window.matchMedia('(min-width: 1101px)');
      let leaveTimer;
      const closeMenus = except => menus.forEach(menu => { if (menu !== except) menu.open = false; });
      menus.forEach(menu => {
        const summary = menu.querySelector(':scope > summary');
        menu.addEventListener('toggle', () => {
          summary?.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) closeMenus(menu);
        }, options);
        menu.addEventListener('pointerenter', event => {
          if (!desktop.matches || event.pointerType === 'touch') return;
          clearTimeout(leaveTimer);
          closeMenus(menu);
          menu.open = true;
        }, options);
        menu.addEventListener('pointerleave', () => {
          if (desktop.matches) leaveTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 160);
        }, options);
        menu.addEventListener('focusout', event => {
          if (!menu.contains(event.relatedTarget)) menu.open = false;
        }, options);
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            menu.open = false;
            summary?.focus();
          }
          if (event.key === 'ArrowDown' && event.target === summary) {
            event.preventDefault();
            menu.open = true;
            menu.querySelector('.ps-mega__panel a')?.focus();
          }
        }, options);
      });
      document.addEventListener('pointerdown', event => { if (!header.contains(event.target)) closeMenus(); }, options);
      const dialog = header.querySelector('[data-ps-nav-dialog]');
      const trigger = header.querySelector('[data-ps-nav-open]');
      const title = dialog?.querySelector('[data-ps-nav-title]');
      const back = dialog?.querySelector('[data-ps-nav-back]');
      const scroll = dialog?.querySelector('.ps-mobile-nav__scroll');
      const views = [...(dialog?.querySelectorAll('[data-ps-nav-view]') || [])];
      let path = ['root'];
      let returnFocus;
      const displayView = (name, moveFocus = true) => {
        const current = views.find(view => view.dataset.psNavView === name);
        if (!current) return false;
        views.forEach(view => { view.hidden = view !== current; });
        if (title) title.textContent = current.dataset.title || '';
        if (back) back.hidden = path.length < 2;
        if (scroll) scroll.scrollTop = 0;
        if (moveFocus) {
          const first = current.querySelector('button, a[href], input');
          (first || back)?.focus();
        }
        return true;
      };
      const closeNav = () => {
        if (dialog?.open) dialog.close();
      };
      trigger?.addEventListener('click', event => {
        if (typeof dialog?.showModal !== 'function') return;
        event.preventDefault();
        returnFocus = trigger;
        closeMenus();
        path = ['root'];
        displayView('root', false);
        dialog.showModal();
        document.documentElement.classList.add('ps-nav-lock');
        trigger.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-ps-nav-close]')?.focus();
      }, options);
      dialog?.addEventListener('click', event => {
        const go = event.target.closest('[data-ps-nav-go]');
        if (go && dialog.contains(go)) {
          const target = go.dataset.psNavGo;
          if (!views.some(view => view.dataset.psNavView === target)) return;
          event.preventDefault();
          path.push(target);
          displayView(target);
          return;
        }
        if (event.target.closest('[data-ps-nav-close]')) closeNav();
        if (event.target.closest('[data-ps-nav-back]') && path.length > 1) {
          path.pop();
          displayView(path[path.length - 1]);
        }
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeNav();
        }
      }, options);
      dialog?.addEventListener('cancel', event => { event.preventDefault(); closeNav(); }, options);
      dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('ps-nav-lock');
        trigger?.setAttribute('aria-expanded', 'false');
        returnFocus?.focus();
      }, options);
      dialog?.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(element => !element.disabled && !element.closest('[hidden]'));
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      desktop.addEventListener('change', event => { closeMenus(); if (event.matches) closeNav(); }, options);
      headers.set(header, () => {
        clearTimeout(leaveTimer);
        closeNav();
        controller.abort();
        headers.delete(header);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    headers.forEach((cleanup, header) => { if (event.target.contains(header)) cleanup(); });
  });
})();
